import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'product',
  entityPlural: 'products',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: true
  }
});
